// src/util/loadImages.js
export const importAllImages = (r) => {
    let images = {};
    r.keys().forEach((item) => { images[item.replace('./', '')] = r(item); });
    return images;
}

export const images = importAllImages(require.context('../images/resumes', false, /\.(png|jpe?g|svg)$/));
export const coverletterimages = importAllImages(require.context('../images/coverletters', false, /\.(png|jpe?g|svg)$/));
